export const asString = (arg: any) => arg as string;
export const asArray = <Item = any>(arg: any) => arg as Item[];
